import { Hr } from './Line.styled';

export const Line = () => <Hr data-testid="lineSeparator" />;
